import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import {buildStyles} from "connectui/component/buildStyles";
import Container from "connectui/component/layout/Container";

const keyframesName = buildStyles({
  "@keyframes ensoai-typing-bounce": {
    "0%, 80%, 100%": {
      transform: "scale(0.7)",
      opacity: 0.7,
    },
    "40%": {
      transform: "scale(1.2)",
      opacity: 1,
    },
  },
})["@keyframes ensoai-typing-bounce"];

const useStyles = (theme) =>
  buildStyles({
    dotsContainer: {
      display: "inline-block",
      minWidth: 32,
    },
    dot: {
      display: "inline-block",
      width: "8px",
      height: "8px",
      margin: "0 2px",
      background: theme.colors.white,
      borderRadius: "50%",
      opacity: 0.7,
      animation: `${keyframesName} 1.4s infinite both`,
      "&:nth-of-type(2)": {
        animationDelay: "0.2s",
      },
      "&:nth-of-type(3)": {
        animationDelay: "0.4s",
      },
    },
  });

const TypingDots = () => {
  const {theme} = useTheme();
  const classes = useStyles(theme);

  return (
    <Container as="span" className={classes.dotsContainer}>
      <Container as="span" className={classes.dot} />
      <Container as="span" className={classes.dot} />
      <Container as="span" className={classes.dot} />
    </Container>
  );
};

export default TypingDots;
